import { Component, OnInit, OnDestroy } from '@angular/core';
import { DialogComponent, DialogService } from 'ng2-bootstrap-modal';
import 'rxjs/add/operator/switchMap';

export interface MessageResendModalModel {
  title: string;
  isSuccess: boolean;
}

@Component({
  selector: 'app-message-resend-modal',
  templateUrl: './message-resend-modal.component.html',
  styleUrls: ['./message-resend-modal.component.css']
})
export class MessageResendModalComponent extends DialogComponent<MessageResendModalModel, boolean> implements OnInit, OnDestroy {
  title: string;
  isSuccess: boolean;
  currentLang: string;
  
  constructor(dialogService: DialogService) {
    super(dialogService);
  }
 
  ngOnInit() {
  	this.currentLang = localStorage.getItem('lang') || 'en';
  	setTimeout(function () {
            document.getElementsByTagName('body')[0].classList.add('modal-open');
    }, 310);
  }
  
  closeModal() {
      this.result = true;
      this.close();
  }

}



// WEBPACK FOOTER //
// C:/Work/Projects/OnlineParser/web2-ui/src/app/custom-modals/message-resend-modal.component.ts